<template>
    <div class="main">
        <div  v-for="item in list"
              :style="item.selected?{'background-color':selectedColor}:{'background-color':mainColor}"
                class="items"
        >
        </div>
    </div>
</template>

<script>
    export default {
        name: "intro-status",
        data() {
            return {

            }
        },
        props:{
            mainColor:{
                type:String,
                default:"#e0e0e0"
            },
            selectedColor:{
                type:String,
                default:"#4fc3f7"
            },
            selectedItem:Number,
            itemsCount:Number
        },
        computed:{
            list(){
                let list=[];
                for(let i=0;i<this.itemsCount;i++){
                    console.log("in cycle")
                    if(this.selectedItem==i){
                        list.push({selected:true})
                    }
                    else{
                        list.push({selected:false})
                    }
                }
                return list;
            }
        },
    }
</script>

<style scoped>
    .items{
        display: inline-block;
        margin:5px;
        width:12px;
        height: 12px;
        border-radius: 100%;
    }
</style>